import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/kidizen-seller-protection-return-policy';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Lowdown on Kidizen Seller Protection and Return Policy</title>
        <meta
          name='description'
          content='Protect your business in cases of returns on Kidizen and learn about how Kidizen protects their sellers like you'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/kidizen-seller-protection-return-policy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/kidizen-seller-protection-return-policy' />
        <meta property='og:title' content='The Lowdown on Kidizen Seller Protection and Return Policy' />
        <meta
          property='og:description'
          content='Protect your business in cases of returns on Kidizen and learn about how Kidizen protects their sellers like you'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Kidizen' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
